import { MutationTree } from 'vuex'
import { PrintedDocumentState } from '@/store/printedDocuments/index'
import { PageResult } from '@/api/types'
import { PrintedDocument } from '@/api/model/printed-document'

export const mutations: MutationTree<PrintedDocumentState> = {
    fetchData(state: PrintedDocumentState): void {
        state.loading = true
        state.totalItems = null
        state.error = null
    },

    fetchDataSuccess(state: PrintedDocumentState, result: PageResult<PrintedDocument>): void {
        state.loading = false
        state.error = null
        state.printedDocuments = result.collection
        state.totalItems = result.totalItems
        state.totalPages = result.totalPages
    },

    fetchDataFailure(state: PrintedDocumentState, error: string): void {
        state.loading = false
        state.error = error
    },

    setPage(state: PrintedDocumentState, payload: {page: number }): void {
        state.page = payload.page
    },

    applyOrder(state: PrintedDocumentState, payload: { field: string, direction: string}): void {
        state.orderField = payload.field
        state.orderDirection = payload.direction
    },

    applyCompanyFilter(state: PrintedDocumentState, payload: {query: string }): void {
        state.companyFilter = payload.query
    },
}
